/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tyc_Indemnification_TitleInputs */

const es_tyc_indemnification_title = /** @type {(inputs: Tyc_Indemnification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Indemnizacion`)
};

const en_tyc_indemnification_title = /** @type {(inputs: Tyc_Indemnification_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`7. Indemnification`)
};

/**
* | output |
* | --- |
* | "7. Indemnification" |
*
* @param {Tyc_Indemnification_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tyc_indemnification_title = /** @type {((inputs?: Tyc_Indemnification_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tyc_Indemnification_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tyc_indemnification_title(inputs)
	return en_tyc_indemnification_title(inputs)
});
export { tyc_indemnification_title as "tyc.indemnification.title" }